'use strict';
import Helpers from '../_helpers';
/**
 * Default Form class
 *
 * @type class
 */
export default class Form {
    /**
     * Constructor
     *
     * @param Config_Interface
     */
    constructor(config) {
        /**
         * Helper
         *
         * @type Helpers
         */
        this.helpers = new Helpers;
        this._config = config;
    }
    /**
     * Form: Start
     *
     * @param   object dataLayer
     */
    start(dataLayer) {
        let _self = this;
        document.querySelectorAll('form.' + this._config.form_class).forEach((form) => {
            let _form_started = false;
            // Attach events to fields
            form.querySelectorAll('input').forEach((field) => {
                field.addEventListener('keydown', (e) => {
                    if (e.isComposing || e.keyCode === 229 || _form_started === true)
                        return;
                    if (Array.isArray(this._config.form_ignore_fields) &&
                        this._config.form_ignore_fields.includes(field.name))
                        return;
                    // Build custom model object for Form
                    let custom_model = {
                        event: '',
                        title: form.dataset.title,
                        url: _self._config.site.href,
                        field_start: field.name,
                        data: form.dataset,
                    };
                    // Check and push dataLayer object reference against custom model
                    window.dataLayer.push(this.helpers.process_datalayer(dataLayer, { form: custom_model }));
                    _form_started = true;
                });
            });
        });
    }
    /**
     * Form: Submit
     *
     * @param   object dataLayer
     */
    submit(dataLayer) {
        let _self = this;
        document.querySelectorAll('form.' + this._config.form_class).forEach((form) => {
            let custom_model = {
                event: '',
                title: form.dataset.title,
                url: _self._config.site.href,
                fields_filled: {},
            };
            form.addEventListener('submit', (e) => {
                const form_elements = Array.from(form.elements);
                /**
                 * Get all non-empty fields and map keys to string
                 *
                 * @type Object
                 */
                let fieldsArr = form_elements
                    .filter((e) => {
                    if (Array.isArray(this._config.form_ignore_fields) &&
                        this._config.form_ignore_fields.includes(e.name))
                        return false;
                    // Input elements
                    if (e instanceof HTMLInputElement) {
                        // Checkbox element
                        if (e.type.toLowerCase() == 'checkbox') {
                            return e.checked == true;
                        }
                        else {
                            return e.value != '';
                        }
                    }
                    // Select elements
                    else if (e instanceof HTMLSelectElement) {
                        let selected = e.options;
                        return selected[selected.selectedIndex].value != '';
                    }
                    // Textarea elements
                    else if (e instanceof HTMLTextAreaElement) {
                        return e.value != '';
                    }
                })
                    .map((e) => {
                    return { name: e.name, value: e.value };
                });
                let fields = {};
                for (var field of fieldsArr) {
                    fields[field.name] = field.value;
                }
                custom_model.fields_filled = fields;
                window.dataLayer.push(_self.helpers.process_datalayer(dataLayer, { form: custom_model }));
            });
        });
    }
    /**
     * Form: Exit
     *
     * beforeunload event is attached if there has been any input on any form fields
     *
     * @param   object dataLayer
     */
    exit(dataLayer) {
        let _self = this;
        document.querySelectorAll('form.' + this._config.form_class).forEach((form) => {
            let _form_started = false;
            // Attach events to fields
            form.querySelectorAll('input').forEach((field) => {
                field.addEventListener('keydown', (e) => {
                    if (e.isComposing || e.keyCode === 229 || _form_started === true)
                        return;
                    _form_started = true;
                    // Build custom model object for Form
                    let custom_model = {
                        event: '',
                        title: form.dataset.title,
                        url: _self._config.site.href,
                        fields_filled: field.name,
                    };
                    addEventListener('beforeunload', () => {
                        let form_elements = Array.from(form.elements);
                        /**
                         * Get all non-empty fields and map keys to string
                         *
                         * @type String
                         */
                        let fields = form_elements
                            .filter((e) => {
                            if (Array.isArray(this._config.form_ignore_fields) &&
                                this._config.form_ignore_fields.includes(e.name))
                                return false;
                            // Input elements
                            if (e instanceof HTMLInputElement) {
                                // Checkbox element
                                if (e.type.toLowerCase() == 'checkbox') {
                                    return e.checked == true;
                                }
                                else {
                                    return e.value != '';
                                }
                            }
                            // Select elements
                            else if (e instanceof HTMLSelectElement) {
                                let selected = e.options;
                                return selected[selected.selectedIndex].value != '';
                            }
                            // Textarea elements
                            else if (e instanceof HTMLTextAreaElement) {
                                return e.value != '';
                            }
                        })
                            .map((e) => {
                            return e.name;
                        })
                            .join(',');
                        custom_model.fields_filled = fields;
                        // Check and push dataLayer object reference against custom model
                        window.dataLayer.push(this.helpers.process_datalayer(dataLayer, { form: custom_model }));
                    }, { capture: true });
                });
            });
        });
    }
}
